module.exports = __webpack_public_path__ + "static/media/swissKnife.18d93704.svg";